import React from 'react'
import Sortable from 'react-sortablejs'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGripLines } from '@fortawesome/pro-regular-svg-icons/faGripLines'
import { faTrash } from '@fortawesome/pro-regular-svg-icons/faTrash'
import styled from 'styled-components'

const SortableRow = styled.tr`
    cursor: grab;

    &:active {
        cursor: grabbing;
    }

    &.sortable-chosen {
        opacity: 0.7;
    }

    &.sortable-ghost {
        background-color: ${props => props.theme.admin.colors.background};
        color: ${props => props.theme.admin.colors.background};
        .btn {
            opacity: 0;
        }
    }

    td {
        vertical-align: middle;
    }
`

const ContentProductRelationshipsList = props => {
    const { settings, setSettings } = props

    const { contentProductLinks } = settings

    return contentProductLinks?.length > 0 ? (
        <table className="table table-sm !mt-4" data-testid="related-products-list">
            <colgroup>
                <col width="5%" />
                <col width="60%" />
                <col width="15%" />
            </colgroup>

            <thead>
                <tr>
                    <th></th>
                    <th>Name</th>
                    <th className="!text-right">Remove</th>
                </tr>
            </thead>

            <Sortable
                tag="tbody"
                onChange={(order, sortable, evt) => {
                    const values = [...contentProductLinks]
                    const movedItem = values[evt.oldIndex]
                    const to = evt.newIndex
                    values.splice(evt.oldIndex, 1)
                    values.splice(to, 0, movedItem)
                    setSettings({
                        ...settings,
                        contentProductLinks: values,
                    })
                }}
                options={{
                    animation: 100,
                }}
            >
                {contentProductLinks.map((item, index) => (
                    <SortableRow key={item.id} data-id={item.id}>
                        <td data-testid={`product-${index}-slider`}>
                            <FontAwesomeIcon icon={faGripLines} />
                        </td>
                        <td data-testid={`product-${index}-name`}>
                            {item?.product?.name || item.name || '-'}
                        </td>
                        <td className="!text-right">
                            <button
                                type="button"
                                className="btn btn-sm btn-danger"
                                onClick={() => {
                                    const values = [...contentProductLinks]
                                    values.splice(index, 1)
                                    setSettings({
                                        ...settings,
                                        contentProductLinks: values,
                                    })
                                }}
                                data-testid={`product-${index}-remove`}
                                style={{
                                    backgroundColor: '#dc3545',
                                }}
                            >
                                <FontAwesomeIcon icon={faTrash} />
                            </button>
                        </td>
                    </SortableRow>
                ))}
            </Sortable>
        </table>
    ) : (
        <p className="!text-center !my-4" data-testid="no-products">
            No products assigned to this content
        </p>
    )
}
export default ContentProductRelationshipsList
